import { v4 as uuidv4 } from "uuid";
const elementTypes = [
  {
    id: uuidv4(),
    type: "logo",
    props: {
      label: "logo",
      width: "100px",
      height: "80px",
      marginTop: "0",
      marginLeft: "0",
    },
  },
  {
    id: uuidv4(),
    type: "heading",
    props: {
      text: "Heading",
      level: "2",
      color: "blue",
      backgroundColor: "#ffffff",
      height: "40px",
      width: "700px",
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  {
    id: uuidv4(),
    type: "textField",
    props: {
      label: "Text Field",
      color: "primary",
      width: "200px",
      height: "50px",
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  {
    id: uuidv4(),
    type: "paragraph",
    props: {
      text: "Paragraph",
      level: "2",
      color: "blue",
      backgroundColor: "#ffffff",
      height: "40px",
      width: "700px",
      padding: "2px",
      fontSize: "12px",
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  {
    id: uuidv4(),
    type: "signature",
    props: {
      label: "Signature",
      width: "600px",
      height: "400px",
      marginTop: "0px",
      marginLeft: "0px",
      signatureMode: "Scribble",
    },
  },
  {
    id: uuidv4(),
    type: "radioSelection",
    props: {
      label: "Radio",
      width: "600px",
      height: "150px",
      options: ["1", "2"],
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  {
    id: uuidv4(),
    type: "fileUpload",
    props: {
      label: "FileName",
      width: "600px",
      height: "250px",
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  {
    id: uuidv4(),
    type: "datePicker",
    props: {
      label: "Date",
      width: "600px",
      height: "55px",
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  {
    id: uuidv4(),
    type: "checkBox",
    props: {
      label: "Checkbox",
      width: "25px",
      height: "25px",
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  {
    id: uuidv4(),
    type: "horizontalContainer",
    props: {
      label: "Horizotal Container",
      height: "200px",
      width: "500px",
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  {
    id: uuidv4(),
    type: "pageBreak",
    props: {
      label: "pageBreak",
      width: "100%",
      height: "80px",
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
];
export default elementTypes;
